import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BreadcrumbInterface } from '../../services/breadcrumbs.service';
import { DeviceType } from '../../models/interfaces/device-type.type';
import { DeviceWidthService } from '../../services/width.service';
import { RouterLink } from '@angular/router';
import { RoadDrawerDirective } from '../../directives/road-drawer.directive';
import { NgIf, NgFor, NgTemplateOutlet, NgClass } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    standalone: true,
    imports: [NgIf, RoadDrawerDirective, NgFor, NgTemplateOutlet, RouterLink, NgClass]
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {
  deviceType: DeviceType = 'desktop';
  private destroy$ = new Subject<void>();

  @Input()
  breadcrumbs!: BreadcrumbInterface[];

  constructor (private deviceWidth: DeviceWidthService
  ) {

  }

  isStep?: any;

  ngOnInit() {
    this.deviceWidth.getDeviceType$()
    .pipe(takeUntil(this.destroy$))
    .subscribe(type => {
      this.deviceType = type;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

